import Sheet from '@mui/joy/Sheet'
import Typography from '@mui/joy/Typography'
import InfoHint from './InfoHint'

interface StatCardProps {
    label: string
    value: string | number
    hint?: string
    /** The detailed explanation in the info tooltip. */
    info?: string
    /** Opens the jobs behind this number. */
    onClick?: () => void
    /** What clicking opens, as the tooltip says it (the Document Jobs list when absent). */
    linkTitle?: string
    tone?: 'neutral' | 'success' | 'warning' | 'danger'
}

const TONE_COLOR = {
    neutral: 'text.primary',
    success: 'success.plainColor',
    warning: 'warning.plainColor',
    danger: 'danger.plainColor',
} as const

/** One number with its label, for the summary row. */
export default function StatCard({ label, value, hint, info, onClick, linkTitle = 'Open these jobs in Document Jobs', tone = 'neutral' }: StatCardProps) {
    return (
        <Sheet
            variant="outlined"
            onClick={onClick}
            role={onClick ? 'link' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={(e) => onClick && e.key === 'Enter' && onClick()}
            title={onClick ? linkTitle : undefined}
            sx={{
                p: 1.5,
                borderRadius: 'md',
                minWidth: 140,
                flex: '1 1 140px',
                ...(onClick && { cursor: 'pointer', '&:hover': { borderColor: 'primary.outlinedBorder', bgcolor: 'background.level1' } }),
            }}
        >
            <Typography level="body-xs" textTransform="uppercase" sx={{ letterSpacing: '0.04em' }}>
                {info ? <InfoHint hint={info}>{label}</InfoHint> : label}
            </Typography>
            <Typography level="h3" sx={{ color: TONE_COLOR[tone] }}>
                {value}
            </Typography>
            {hint && <Typography level="body-xs">{hint}</Typography>}
        </Sheet>
    )
}
